import { Socket } from "./Socket";
export class Json extends Socket {
    processReceived(data) {
        return JSON.parse(data?.arrayBuffer
            ? new TextDecoder().decode(data.arrayBuffer())
            : typeof data != "string"
                ? new TextDecoder().decode(data)
                : data);
    }
    processSend(data) {
        return JSON.stringify(data);
    }
}
//# sourceMappingURL=Json.js.map